module.exports = __webpack_public_path__ + "img/prize-type-1.bd289501.png";